"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValuesFromEnum = exports.getStringValuesFromEnum = void 0;
function getStringValuesFromEnum(enumType) {
    const keys = Object.keys(enumType).filter(k => typeof enumType[k] === "string");
    const values = keys.map(k => enumType[k]);
    return values;
}
exports.getStringValuesFromEnum = getStringValuesFromEnum;
function getValuesFromEnum(enumType) {
    return Object.values(enumType);
}
exports.getValuesFromEnum = getValuesFromEnum;
//# sourceMappingURL=get-str-values-from-enum.js.map